"use client";
import React, { useState } from "react";
import { Drawer } from "vaul";
import { X } from "lucide-react";
import { fetchWrapper } from "@/helpers";
import { usePWA } from "@/utlis/usePWA";
import { useIsMobile } from "@/utlis/useIsMobile";

const isEditMode = (mode) => mode === "adminEdit" || mode === "ownEdit";

export default function QuestionForm({ mode = "create", productID, initialData, onClose, onSuccess }) {
	const isPWA = usePWA();
	const isMobile = useIsMobile();
	const isCompact = isPWA || isMobile;

	const [text, setText] = useState(initialData?.text || "");
	const [submitting, setSubmitting] = useState(false);
	const [error, setError] = useState("");

	const handleSubmit = async (e) => {
		e.preventDefault();
		setError("");

		if (!text.trim()) return setError("Scrie întrebarea ta.");

		setSubmitting(true);
		try {
			const payload = { text: text.trim() };

			if (mode === "adminEdit") {
				await fetchWrapper.put(`/api/admin/questions/${initialData.id}`, payload);
			} else if (mode === "ownEdit") {
				await fetchWrapper.put(`/api/questions/${initialData.id}/own`, payload);
			} else {
				await fetchWrapper.post(`/api/questions/${productID}`, payload);
			}

			onSuccess?.();
			onClose?.();
		} catch (err) {
			setError(typeof err === "string" ? err : "A apărut o eroare. Încearcă din nou.");
		} finally {
			setSubmitting(false);
		}
	};

	const formBody = (
		<form className='tf-review-form' onSubmit={handleSubmit}>
			<div className='tf-review-form-field'>
				<label htmlFor='question-text'>Întrebarea ta</label>
				<textarea
					id='question-text'
					rows={4}
					value={text}
					onChange={(e) => setText(e.target.value)}
					placeholder='Ce vrei să afli despre acest produs?'
				/>
			</div>

			{error && <div className='tf-review-form-error'>{error}</div>}

			<button type='submit' className='tf-review-form-submit' disabled={submitting}>
				{submitting ? "Se trimite..." : isEditMode(mode) ? "Salvează modificările" : "Trimite întrebarea"}
			</button>
		</form>
	);

	if (isCompact) {
		return (
			<Drawer.Root open onOpenChange={(open) => !open && onClose?.()}>
				<Drawer.Portal>
					<Drawer.Overlay className='tf-review-drawer-overlay' />
					<Drawer.Content className='tf-review-drawer-content'>
						<Drawer.Handle />
						<div className='tf-review-drawer-body'>
							<Drawer.Title className='tf-review-drawer-title'>
								{isEditMode(mode) ? "Editează întrebarea" : "Pune o întrebare"}
							</Drawer.Title>
							{formBody}
						</div>
					</Drawer.Content>
				</Drawer.Portal>
			</Drawer.Root>
		);
	}

	return (
		<div className='tf-review-modal-overlay' onClick={onClose}>
			<div className='tf-review-modal-content' onClick={(e) => e.stopPropagation()}>
				<div className='tf-review-modal-header'>
					<h4>{isEditMode(mode) ? "Editează întrebarea" : "Pune o întrebare"}</h4>
					<button type='button' onClick={onClose} aria-label='Închide'>
						<X size={20} />
					</button>
				</div>
				{formBody}
			</div>
		</div>
	);
}
